module.exports = __webpack_public_path__ + "img/lanebylens.862ed770.png";